<div class="c-site-middle-content-inner" id="divMiddleContent">
  <app-page-header id="comPageHeader"></app-page-header>
  <app-page-content id="comPageContent"></app-page-content>
</div>
